// extracted by mini-css-extract-plugin
export default {"details-box":"details-box_details-box__iPm96"};